































import { Component, Vue, Prop } from 'vue-property-decorator'
import { required } from 'vuelidate/lib/validators'
import { isDate, datePickerValidation } from '@/utils'

@Component({
	name: 'Datepicker',
	validations: {
		modelData: {
			required,
			isDate,
			datePickerValidation
		}
	}
})
export default class Datepicker extends Vue {
	@Prop()
	private date!: string
	@Prop()
	private prevDate!: string
	@Prop({ default: false })
	private extendedPeriod!: boolean
	@Prop({ default: false })
	private isDisabled!: boolean
	private modelData: string = this.date

	private onDatePickerInput (date: string): void {
		const datepickerRef: any = this.$refs.qDateProxy

		// hiding calendar modal when it's open
		if (datepickerRef.$refs.popup.showing) {
			datepickerRef.hide()
		}

		this.$emit('field-updated', date)
	}
}
